export const environment = {
  storage_key: '2a554677-086a-4f1b-a83b-c82433d1288f',
  web_url: 'https://uat.osquare.solutions',
  polls_base_url: 'https://api-polls-uat.osquare.solutions',
  base_url: 'https://api-uat.osquare.solutions',
  authUrl: 'https://auth-uat.osquare.solutions',
  payroll_url: 'https://payroll-uat.osquare.solutions',
  payroll_base_url: 'https://api-payroll-uat.osquare.solutions',
  leadKonnekt_url: 'https://leadkonnect-uat.osquare.solutions',
  accounting_url: 'https://accounting-uat.osquare.solutions',
  inventory_url: 'https://inventory-uat.osquare.solutions',
  recruitmentBaseUrl: 'https://api-recruitment-uat.osquare.solutions',
  easy_form_url: 'https://easyform-uat.osquare.solutions',
  easy_form_base_url: 'https://api-easyform-uat.osquare.solutions',
  cookieDomain: 'qa.osquare.solutions',
  easy_fee_url: 'https://easyfee-uat.osquare.solutions',
  ischool_url: 'https://ischool-uat.osquare.solutions',
  obrain_url: 'https://qa-ai.osquare.solutions',
  ai_url: 'https://qa-ai.osquare.solutions',
  loans_and_advances_base_url: 'https://69d1pzp4-5039.uks1.devtunnels.ms',
  leadKonnekt_base_url: 'https://api-easyform-uat.osquare.solutions',
  accounting_base_url: 'https://api-accounting-uat.osquare.solutions',
  inventory_base_url: 'https://api-inventory-uat.osquare.solutions',
  easy_fee_base_url: 'https://easyfee-uat.osquare.solutions',
  invoices_base_url: 'https://k5082kg7-7269.inc1.devtunnels.ms',
  appraisals_url: '#',
  appraisal_base_url: '#',
  sqa_url: 'https://sqa-uat.osquare.solutions',
  version: '2.6.0',
  production: true,
  emptyGuid: '00000000-0000-0000-0000-000000000000',
  projectID: 'bd6a2fad-34a3-4ad6-feeb-08dd040f0f58',
};

export const google_env = {
  client_id:
    '948363784718-r8u3b7g58cscn33ho4j4odskgleunjoe.apps.googleusercontent.com',
  client_secret: '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',
  redirect_uri: 'https://uat.osquare.solutions/app/auth/callback/google',
  api_key: 'AIzaSyDwF7yqw630VKmLLubwGZH38GIDFM350Us',
};

